import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Masthead = _resolveComponent("Masthead")!
  const _component_PaginatedResourceTable = _resolveComponent("PaginatedResourceTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Masthead, {
      "component-testid": "secrets-list",
      schema: $props.schema,
      resource: $props.resource,
      "create-location": $options.createLocation
    }, null, 8, ["schema", "resource", "create-location"]),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createVNode(_component_PaginatedResourceTable, {
      schema: $props.schema,
      headers: $data.namespacedHeaders,
      "pagination-headers": $data.namespacedHeadersSsp,
      "use-query-params-for-simple-filtering": $props.useQueryParamsForSimpleFiltering
    }, null, 8, ["schema", "headers", "pagination-headers", "use-query-params-for-simple-filtering"])
  ]))
}